import { render, staticRenderFns } from "./MangheWish.vue?vue&type=template&id=98258442&"
import script from "./MangheWish.vue?vue&type=script&lang=js&"
export * from "./MangheWish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports